import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const showNotification = (message, type, style) => {
    setNotifications((prev) => [...prev, { message, type, style }]);
    toast[type](message, {
        position: "top-right",
        autoClose: 20000,
        style: {
          ...style,
          width:"300px",
          marginTop: "100px", // Décale la notification vers le bas
          marginLeft: "-100px",
          //marginRigth:"10px"
        },
  });
};

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useNotification = () => {
  return useContext(NotificationContext);
};
